import { AfterViewInit, Component, ContentChildren, Input, QueryList } from '@angular/core';
import { GridColDirective } from './grid-col.component';
import * as _ from 'underscore';

@Component({
  selector: 'grid',
  template: `
		<div class="row">
			<div [class.col-sm-6]="!isInDialog || (isInDialog && columns[1].length > 0)" [class.col-sm-12]="isInDialog && columns[1].length === 0" *ngFor="let children of columns">
				<ng-container *ngFor="let child of children">
					<ng-template *ngTemplateOutlet="child.template"></ng-template>
				</ng-container>
			</div>
		</div>
	`
})
export class GridComponent implements AfterViewInit {
  @ContentChildren(GridColDirective) public children:QueryList<GridColDirective>;
  @Input() public isInDialog:boolean;
  public columns:Array<GridColDirective[]>;

  public ngAfterViewInit():void {
    // listen on gridCol changes
    this.children.changes.subscribe((elems:QueryList<GridColDirective>) => {
      // partition to total elements by 2 cols
      this.columns = _.partition(elems.toArray(), (elem, idx) => idx % 2 === 0);
    });
  }
}